import { Component } from "@angular/core";

@Component({
  selector: "app-geofence-blocked",
  templateUrl: "./geofence-blocked.component.html",
  styleUrls: ["./geofence-blocked.component.scss"],
})
export class GeofenceBlockedComponent {}
